<label>{{label}}</label>
<button *ngFor="let i of links" [ngClass]="i.theme" [style.--fc-ql-icon]="getIcon(i)" (click)="onClick(i)">
    {{i.text}}
</button>